import { ApplicationState } from '@/store';
import { clearSuccessfullRegisterToast } from '@/store/apply/actions';
import { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { SuccessToast } from '../components/SuccessToast';
import { useToast } from '@chakra-ui/react';

export function useRegisterToast(onClose: () => void) {
  const toast = useToast();
  const dispatch = useDispatch();

  const showSuccessfulRegisterToastUni = useSelector(
    ({ apply }: ApplicationState) => apply.registration.uni.showSuccessfullRegisterToast,
  );
  const showSuccessfulRegisterToastAgent = useSelector(
    ({ apply }: ApplicationState) => apply.registration.agent.showSuccessfullRegisterToast,
  );
  const showSuccessfulRegisterToastPartner = useSelector(
    ({ apply }: ApplicationState) => apply.registration.partner.showSuccessfullRegisterToast,
  );

  const lastRegisteredApplicant = useSelector(
    ({ apply }: ApplicationState) => apply.lastRegisteredApplicant,
    shallowEqual,
  );

  useEffect(() => {
    const showSuccessfulRegisterToast =
      showSuccessfulRegisterToastUni || showSuccessfulRegisterToastAgent || showSuccessfulRegisterToastPartner;
    if (showSuccessfulRegisterToast && lastRegisteredApplicant?.data) {
      onClose();
      const { preferredName, uni, userId } = lastRegisteredApplicant.data;

      toast({
        id: `successfull-agent-register-toast-${userId}`,
        render: ({ onClose: onCloseToast }) => (
          <SuccessToast onClose={onCloseToast} preferredName={preferredName} uni={uni} userId={userId} />
        ),
        status: 'success',
        duration: 20000,
        isClosable: true,
      });

      dispatch(clearSuccessfullRegisterToast());
    }
  }, [
    showSuccessfulRegisterToastUni,
    showSuccessfulRegisterToastAgent,
    showSuccessfulRegisterToastPartner,
    lastRegisteredApplicant,
  ]);
}
